<template>
  <div class="assignment-overall">
    <el-row>
      <el-col :span="12">
        <div class="assignment-overall__left">
          <span class="assignment-overall__score-heading text-bold">
            {{ $t("assignments.details.lesson_title") }}
          </span>
          <assignment-a-i-tutor-lesson :lesson="lesson" :order="1" />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="assignment-overall__right">
          <div class="assignment-score">
            <span class="assignment-score__label assignment-score__label--text-black"></span>
            <span class="assignment-score__value text-gray text-bold">
              {{ isCompanyOrg ? $t('ai_tutor.ent.team_average') : $t("assignments.details.class_average")  }}
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">
              {{ $t("ai_tutor.label_table_performance.lesson_score") }}
            </span>
            <span class="assignment-score__value text-bold">
              {{ formatScore(lesson.score) }}
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">
              {{ $t("ai_tutor.metrics.pronunciation") }}
            </span>
            <span class="assignment-score__value text-bold text-capitalize">
              {{ formatText(lesson.pronunciation) }}
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">
              {{ $t("assignments.details.vocabulary") }}
            </span>
            <span class="assignment-score__value text-bold text-capitalize">
              {{ formatText(lesson.vocabulary) }}
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">
              {{ $t("assignments.details.grammar") }}
            </span>
            <span class="assignment-score__value text-bold text-capitalize">
              {{ formatText(lesson.grammar) }}
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AssignmentAITutorLesson from "./AssignmentAITutorLesson.vue";
import { mapGetters } from "vuex";
import { COMPANY } from "@/constants/organizationType";
export default {
  components: {
    AssignmentAITutorLesson,
  },
  props: {
    lesson: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    formatScore(score) {
      return score ? Math.round(score) + "%" : "--";
    },
    formatText(str) {
      if (!str) {
        return "--";
      }

      return this.$t(`charts.elsa_score_range.${str.toLowerCase()}`);
    },
    formatTextRemoveCharacter(text) {
      if (!text) return "";
      return text.replace(/\(\w*\)/gm, "").trim();
    },
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    isCompanyOrg() {
      return this.currentOrganizationType === COMPANY
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.assignment-overall {
  font-size: 16px;
  font-weight: 600;

  &__score-heading {
    margin-bottom: 20px;
    color: $gray-1;
  }

  &__left {
    display: flex;
    flex-direction: column;
    padding-right: 24px;
  }

  &__right {
    padding-left: 24px;
    padding-right: 20px;
    border-left: 1px solid $gray-2;
  }
}
.assignment-score {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 15px;

  &:last-child {
    padding-bottom: 0;
  }

  &__label {
    color: $gray-1;
    line-height: 24px;
    width: 60%;
    &--text-black {
      color: $black;
    }
  }
  &__value {
    display: flex;
    justify-content: center;
    width: 40%;
    margin-left: auto;
  }
}
.text-capitalize {
  text-transform: capitalize;
}
.text-gray {
  color: $gray-1;
}
</style>
